import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import { refreshtoken } from './qingqiu'
import { setToken } from '../../store/actions'
import { token } from '../../store/getters'
import {axiosTimer} from '../../io/axiosTimer.js'
import {getCookieInfo,clearAllCookie} from '../../io/getCookie.js'
import Cookies from 'js-cookie'
// baseUrl 
//郑本地接口地址
axios.defaults.baseURL = "/yiankb-mystore" 

/*是否有请求正在刷新token*/
window.isRefreshing = false
/*被挂起的请求数组*/
let refreshSubscribers = []

/*push所有请求到数组中*/
function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}

/*刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）*/
function onRrefreshed (token) {
  refreshSubscribers.map(cb => cb(token))
}

/*请求拦截器*/  
axios.interceptors.request.use(function (config) {
	let token =  localStorage.getItem('token') || getCookieInfo('access_token')||'';
	let refreshToken=window.localStorage.getItem("refresh_token")||getCookieInfo('refresh_token')||'';  
    const loginType = localStorage.getItem('loginType')||Cookies.get('loginType')||'';
    config.headers["userfrom"] = 'tcmkb'
	if(token){ 
		config.headers["Authorization"] = 'bearer' +token ;  
      if(loginType){
        config.headers['X-Login-T'] = loginType
      }
		if(refreshToken){
			axiosTimer(refreshToken)
		}
	} 
	let $loadingBox = document.querySelector('.loading-box');
	$loadingBox && ($loadingBox.style.display = 'flex');
	return config;
}, function (error) {
	return Promise.reject(error);
});


// /*请求拦截器*/
// axios.interceptors.request.use(
//   config => {
    
//     // 获取token
//     const token = localStorage.getItem('token');
//     const token_type = localStorage.getItem('token_type');
    
//     const loginType = localStorage.getItem('loginType');
//     /*判断是否已登录*/
//     if (token) {
//         /*判断auth是否存在*/
//         /*在请求头中添加token类型、token*/
//         config.headers['Authorization'] = token_type + ' ' + token
//         if(loginType){
//           config.headers['X-Login-T'] = loginType
//         }
//         /*判断token是否将要过期*/
//         //判断是否过期
//         //现在的时间戳
//         var nowrefreshFlag = new Date().getTime();
//         //拿到域里的时间
//         var refreshFlag = localStorage.getItem('expir');
//         if (nowrefreshFlag > refreshFlag) {
//           /*判断是否正在刷新*/
//           if (!window.isRefreshing) {
//             /*将刷新token的标志置为true*/
//             window.isRefreshing = true
//             /*发起刷新token的请求*/
//             const refreshToken = localStorage.getItem('refresh_token');
//             //刷新token
//             localStorage.clear()
//             refreshtoken(refreshToken).then(res2 => {
//                 /*将标志置为false*/
//                 window.isRefreshing = false
//                 var Ttoken = res2.access_token
//                 var refresh_token = res2.refresh_token
//                 var Ttoken_type = res2.token_type
//                 var expir = res2.expires_in * 1000 / 2 + new Date().getTime();
//                 window.localStorage.setItem("token", Ttoken);
//                 window.localStorage.setItem("token_type", Ttoken_type);
//                 window.localStorage.setItem("refresh_token", refresh_token);
//                 window.localStorage.setItem("expir", expir);
//                 config.headers['Authorization'] = `${Ttoken_type} ${Ttoken}`
//               /*执行数组里的函数,重新发起被挂起的请求*/
//               onRrefreshed(Ttoken)
//               /*执行onRefreshed函数后清空数组中保存的请求*/
//               refreshSubscribers = []
//             }).catch(err => {
//               console.log(err.response.data.message)
//               return config;
//             })
//           }
//           /*把请求(token)=>{....}都push到一个数组中*/
//           let retry = new Promise((resolve, reject) => {
//             /*(token) => {...}这个函数就是回调函数*/
//             subscribeTokenRefresh((token) => {
//               config.headers['Authorization'] = 'Bearer ' + token
//               /*将请求挂起*/
//               resolve(config)
//             })
//           })
//           return retry
//         }
      
//       return config

//     } else {
//       /*未登录直接返回配置信息*/
//       return config
//     }
//   },
//   /*错误操作*/
//   err => {
//     return Promise.reject(err)
//   }
// )


//重试队列，每一项将是一个待执行的函数形式
let request = []

axios.interceptors.response.use(res => {
    if(res&&res.data&&res.data.code=='401'){
        // console.log(response,"401")
        window.localStorage.clear();  
        clearAllCookie();
    } 
    return res;
}, err => {
    console.log(err)
    return Promise.reject(err)
})

//     if(token){}
//     const token = localStorage.getItem('token');
//     const refresh_token  = localStorage.getItem('refresh_token');
//     const token_type = localStorage.getItem('token_type');
//     if (token) {
//         config.headers.common['Authorization'] = `${token_type}?${token}`;
//     }
//     config.headers.common['deviceId'] = 'deviceId123456789';

//     return config
//  }, function (error) {
//         // 对请求错误做些什么
//         return error
// });

/**
 * 设置拦截器，interceptors 响应处理
 * 所有使用 axios 的请求响应，都会优先回调到拦截器中
 * 在正确的返回情况下，数据会优先进入第一个回调方法
 * 在请求错误的情况下，错误会进入第二个回调方法
 */
// axios.interceptors.response.use((response) => {
//     //  统一处理数据，使组件中的请求只获取到需要的业务数据，
//     // 而不需要去关注返回的状态码等与业务无关的数据
//     // console.log('响应拦截器');

//     return response.data;
//  }, (error) => {
//     // 处理错误的响应
//     return Promise.reject(error);
//  }),


/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
axios.adornParams = (params = {}, openDefultParams = true) => {
    let defaults = {
        't': new Date().getTime()
    }
    return openDefultParams ? merge(defaults, params) : params
};

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
axios.gets = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err.data)
        })
    });
};


/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
axios.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
    
     let defaults = {
         't': new Date().getTime()
     };
    let data1 = openDefultdata ? merge(defaults, data) : data;
    return contentType === 'json' ? JSON.stringify(data1) : qs.stringify(data1);
};

axios.jsonContent = () => {
    let defaults = {
        'headers': { 'Content-Type': 'application/json; charset=utf-8'}
    };
    
    return defaults;
};

//  绑定到 vue 原型中，组件中 ： this.$http -> axios 。

export default axios
Vue.prototype.$http = axios;
